// TODO: move to GeometryLayer
function addMaterialLayerProperty(layer, key, value) {
  layer.defineLayerProperty(key, value, function () {
    var root = layer.parent ? layer.parent.object3d : layer.object3d;
    root.traverse(function (object) {
      if (object.layer == layer && object.material) {
        object.material[key] = layer[key];
      } else if (object.content && object.content.layer == layer) {
        object.content.traverse(function (o) {
          if (o.material) {
            o.material[key] = layer[key];
          }
        });
      }
    });
  });
}

export default {
  addWireFrameCheckbox: function addWireFrameCheckbox(gui, view, layer) {
    gui.add(layer, 'wireframe').name('Wireframe').onChange(function () {
      return view.notifyChange(layer);
    });
  },
  addMaterialSize: function addMaterialSize(gui, view, layer, begin, end) {
    addMaterialLayerProperty(layer, 'size', 1);
    gui.add(layer, 'size', begin, end).name('Size').onChange(function () {
      return view.notifyChange(layer);
    });
  },
  addMaterialLineWidth: function addMaterialLineWidth(gui, view, layer, begin, end) {
    addMaterialLayerProperty(layer, 'linewidth', 1);
    gui.add(layer, 'linewidth', begin, end).name('Line Width').onChange(function () {
      return view.notifyChange(layer);
    });
  },
  createGeometryDebugUI: function createGeometryDebugUI(datDebugTool, view, layer) {
    var gui = datDebugTool.addFolder("Layer ".concat(layer.id));
    gui.add(layer, 'visible').name('Visible').onChange(function () {
      return view.notifyChange(layer);
    });
    gui.add(layer, 'opacity', 0, 1).name('Opacity').onChange(function () {
      return view.notifyChange(layer);
    });
    return gui;
  }
};